import { Link } from 'react-router';
import cs from 'classnames';
import { useNavigationsQuery } from '@data/navigations/useNavigationsQuery';
import { useDeviceType } from '@ui/utils/useDeviceType';
import { DeviceType } from '@repo/types';

type NavigationProps = {
  className?: string;
};

function Nav({ className }: NavigationProps) {
  const { data, isLoading, error } = useNavigationsQuery();
  const deviceType = useDeviceType();

  if (isLoading) {
    return null;
  }

  const headerNavigation = data?.header;
  const navigationNodes = deviceType === DeviceType.mobile || deviceType === DeviceType.tablet ? headerNavigation?.mobileNodes : headerNavigation?.desktopNodes;

  if (error || !navigationNodes || navigationNodes.length === 0) {
    return null;
  }

  return (
    <nav className={cs('nav', className)}>
      <ul className="nav__list">
        {navigationNodes.map((item) => (
          <li className="nav__list-item" key={item.label}>
            {item.url ? (
              <Link
                className="nav__link standalone"
                to={item.url.includes('.') && !item.url.startsWith('http') ? `https://${item.url}` : item.url}
                target={item.sameTab ? '_self' : '_blank'}
              >
                {item.label}
              </Link>
            ) : (
              item.label
            )}
            {item.children && item.children.length > 0 && (
              <ul>
                {item.children.map((child) => (
                  <li key={child.id}>
                    {child.url ? (
                      <Link
                        className="nav__link standalone"
                        to={
                          child.url.includes('.') && !child.url.startsWith('http') ? `https://${child.url}` : child.url
                        }
                        target={item.sameTab ? '_self' : '_blank'}
                      >
                        {child.label}
                      </Link>
                    ) : (
                      child.label
                    )}
                  </li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul>
    </nav>
  );
}

export default Nav;
